import React from "react";
import DataTableBase from "../../../../ui/data_tables/DataTableBase";
import {Image} from "react-bootstrap";
import {gql, useQuery} from "@apollo/client";
import Tools from "../../../../../Tools";
import manchesterUnitedLogo from "../../../../../assets/img/demo/manchester-united-logo.png";
import realMadridLogo from "../../../../../assets/img/demo/real-madrid-logo.png";

class TransfersDataTable extends DataTableBase {

    renderTeam = (teamData) => {
        const {name, logo} = teamData;

        return (
            <div className="team">
                <Image className="team-avatar" src={logo}/>
                <span className="team-name"> {name} </span>
            </div>
        )
    };


    /**
     * Renders datatable row.
     * @param rowData {object} The data json object.
     * @param rowIndex {integer} The index of the row.
     * @returns {{teamJoined: *, teamLeft: *}} The rendered row.
     */
    renderRow = (rowData, rowIndex) => {
        const {teamLeft, teamJoined} = rowData;
        return {
            ...rowData,
            teamLeft: this.renderTeam(teamLeft),
            teamJoined: this.renderTeam(teamJoined),
        };
    };

    /**
     * Returns the table columns configurations.
     * @returns {{dataField: string, text: string, headerTitle: string, sort :boolean}[]} .
     * dataField: the dataField.
     * text: The column display name.
     */
    columnsConfig = () => {
        return [
            {
                dataField: 'season',
                text: 'Season',
            }, {
                dataField: 'transferDate',
                text: 'Transfer Date',
            }, {
                dataField: 'joiningDate',
                text: 'Joining Date',
            }, {
                dataField: 'teamLeft',
                text: 'Team Left',
            }, {
                dataField: 'teamJoined',
                text: 'Team Joined',
            }, {
                dataField: 'role',
                text: 'Role',
            }, {
                dataField: 'transferType',
                text: 'Transfer Type',
            }, {
                dataField: 'marketValue',
                text: 'Market Value',
            }, {
                dataField: 'agency',
                text: 'Agency',
            }, {
                dataField: 'agent',
                text: 'Agent',
            }, {
                dataField: 'coach',
                text: 'Coach',
            },
        ];
    };

    expandRowConfig = () => {
        return {
            enable: false,
        };
    };

    selectRowConfig = () => {
        return {
            enable: false,
        };
    };

    extraClasses = {
        table: 'transfers-datatable'
    };
}

const TransfersDataTableDataWrapper = props => {
    const query = gql`
        query getPlayedTransfers ($playerId: String!) {
            transfers: playerTransfers(player: $playerId){
                #Season ***

                transferDate
                joiningDate
                teamLeft{
                    name
                }
                teamJoined{
                    name
                }
                role
                transferType
                marketValue
                agency{
                    name
                }
                agent{
                    fullName
                }
                coach{
                    fullName
                }
            }
        }
    `;

    const formatter = transfers => {
        if (!transfers)
            return [];

        return transfers.map((transfer) => ({
            season: '2018-19',
            transferDate: Tools.formatDate(transfer.transferDate),
            joiningDate: Tools.formatDate(transfer.joiningDate),
            teamLeft: {
                name: transfer.teamLeft?.name,
                logo: manchesterUnitedLogo,
            },
            teamJoined: {
                name: transfer.teamJoined?.name,
                logo: realMadridLogo,
            },
            role: transfer.role,
            transferType: transfer.transferType,
            marketValue: transfer.marketValue,
            agency: transfer?.agency?.name,
            agent: transfer?.agent?.fullName ?? "Rodrics Marsh", // TODO: Remove it
            coach: transfer?.coach?.fullName ?? "Mark Anthony",
        }));
    };

    const {playerId} = props;

    const {loading, error, data} = useQuery(query, {
        variables: {
            playerId: playerId
        }
    });

    return (
        <TransfersDataTable loading={loading} error={error} rows={formatter(data?.transfers)}/>
    );
};

export default TransfersDataTableDataWrapper;
